import React, { type ReactNode, useEffect } from 'react';
import {
	reportHydrationEnd,
	getIsHydrationInProgress,
	useGlobalHydrationActions,
} from '@atlassian/jira-ssr-controller/src/use-is-page-hydrating.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { RenderAfterHydrationCompletion } from './RenderAfterHydrationCompletion.tsx';

const Setter = () => {
	reportHydrationEnd();
	return null;
};
/**
 * Sets global state indicating hydration has finished. Can also be safely used without hydration being used.
 */
const HydrationFinishedSetterOld = (): ReactNode => {
	return (
		<RenderAfterHydrationCompletion>
			<Setter />
		</RenderAfterHydrationCompletion>
	);
};

const HYDRATION_GLOBAL_TIMEOUT = 60_000;
const HydrationGlobalTimeoutFallback = (): ReactNode => {
	const actions = useGlobalHydrationActions();
	// Fallback if hydration is truly stuck
	useEffect(() => {
		const timer = setTimeout(() => {
			if (getIsHydrationInProgress()) {
				log.safeErrorWithoutCustomerData(
					'hydration-global-timeout',
					`Failed to mark hydration as globally complete after ${HYDRATION_GLOBAL_TIMEOUT}ms timeout`,
				);
				actions.reportHydrationEnd();
			}
		}, HYDRATION_GLOBAL_TIMEOUT);
		return () => {
			clearTimeout(timer);
		};
	}, [actions]);

	return null;
};

export const HydrationFinishedSetter = componentWithCondition(
	() => fg('jfp-magma-fix-hydration-completion'),
	HydrationGlobalTimeoutFallback,
	HydrationFinishedSetterOld,
);
